import React from "react";
import "./Header.css";
import hosting from "../resources/images/hostingFull.jpg";

type HeaderProps = {
  title: string;
  height?: number;
};
/** A header for content pages including a background image and a title */
function Header({title, height = 460}: HeaderProps) {
  return (
    <div className="header">
      <img src={hosting} alt={""} style={{height: height}} />
      <h1 className="header__title">{title}</h1>
    </div>
  );
}

export default Header;
